import { render, staticRenderFns } from "./zoom.vue?vue&type=template&id=06a08428&"
import script from "./zoom.vue?vue&type=script&lang=js&"
export * from "./zoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports